import React from 'react';
import SocialButtonList from './SocialButtonList';
import { AirtableDataConsumer } from '../core/AirtableDataProvider';
import ParameterMap from '../core/ParameterMap';
import AirtableImage from '../core/AirtableImage';
import MarkdownContent from './MarkdownContent';

interface Props {

}

export default class Footer extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data.generalParameters) }
      </AirtableDataConsumer>
    );
  }

  _render(general: ParameterMap)
  {
    const footerNote = general.getContentOrNull('FooterNote');

    return (
      <footer>
        <div className="flex justify-center bg-light-gray bb b--black">
          <div className="flex-auto wfull flex-l justify-between pa4">

            <div className="f6">
              <AirtableImage
                image={ general.getImage('VendorLogo') }
                render={ url => <img alt="vendor logo" className="db mw5" src={ url } /> } />
              <p>{ general.getValue('Phone') } | { general.getValue('Email') }</p>
              <p>{ general.getValue('Address') }</p>
            </div>

            <section className="mw6 f6 mt4 mt0-ns">
              <h3 className="ttu normal gray f4-ns mt0">About Us</h3>
              <MarkdownContent source={ general.getContent('AboutContent') } />
            </section>

          </div>
        </div>

        <div className="flex justify-center">
          <div className="flex-auto flex flex-row f6 wfull pa3 pa4-ns items-center">
            <div className="flex-auto">
              <div>
              &copy; Copyright { new Date().getFullYear() } Irvin Group, LLC dba { general.getValue('CompanyName') }
              </div>
              { footerNote && <MarkdownContent source={ footerNote } /> }
              <div>
                <a href="/terms">Terms of Use</a> <a href="/privacy">Privacy Policy</a> 
              </div>
            </div>
              
            <div>
              <SocialButtonList color={ 'gray' }/>
            </div>
          </div>
        </div>

      </footer>
    );
  }

}
